import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Aside from "~components/aside/aside"
import Link from "~components/link/link"

const TopicSeries = ({ topics = [] }) => {
  const { allSitePage: allTopics } = useStaticQuery(
    graphql`
      query {
        allSitePage(
          filter: { path: { regex: "/^/solutions/use-cases/.+/" } }
          sort: { fields: [pageContext___title], order: ASC }
        ) {
          nodes {
            path
            context: pageContext {
              title
            }
          }
        }
      }
    `
  )

  if (!topics || !topics.length) return null
  const topicsDetails = topics.map((t) => allTopics.nodes.find((n) => n.path.endsWith(`/${t}/`)))

  return (
    <Aside type="hint">
      This page is part of a series in the{" "}
      {topicsDetails.map(({ path, context: { title } }, i) => (
        <>
          <Link to={path}>{title}</Link>
          {topics.length > 1 ? (i < topics.length - 1 ? (i === topics.length - 2 ? " and " : ", ") : "") : ""}
        </>
      ))}{" "}
      <Link to="/solutions/use-cases/">use case{topics.length > 1 ? "s" : ""}</Link>.
    </Aside>
  )
}

export default TopicSeries
